import React from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';
import { setQueries } from '../../libs/setQueries';
import TableLayout from '../../components/shared/TableLayout';
import getColumns from './getColumns';
import { FleetBookingData } from '../../@types';
import {
  fetchBookings,
  selectDisplayBookings,
  selectSelectedBooking,
  selectBooking,
  selectTotalBookings,
  fetchBookingById,
} from '../../redux/store/userData/trips';
import { selectDisplayColumnsForBooking } from '../../redux/store/ui/common';
import { selectCars } from '../../redux/store/userData/cars';
import { selectAreas } from '../../redux/store/appData/areas';
import { useIntl } from 'react-intl';
import { useQuery } from '../../hooks/useQuery';
import withPaginatedQueryFetch from '../../hoc/withPaginatedQueryFetch';
import { getFilteredColumns } from '../../utils';

type Props = {
  pageNumber?: number;
  onPageChanged?: (page: number, pageSize?: number) => void;
};

const BookingsTable = ({ pageNumber, onPageChanged }: Props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const queries = useQuery();
  const cars = useSelector(selectCars);
  const areas = useSelector(selectAreas);
  const selectedBooking = useSelector(selectSelectedBooking);
  const displayBookings = useSelector(selectDisplayBookings);
  const bookingsNo = useSelector(selectTotalBookings);
  const displayColumns = useSelector(selectDisplayColumnsForBooking);
  const columns = getColumns(intl, cars, areas);
  const filteredColumns = getFilteredColumns(columns, displayColumns);

  const onClickRow = (record: FleetBookingData) => {
    batch(() => {
      dispatch(selectBooking(record));
      dispatch(fetchBookingById(record.id));
    });

    setQueries({
      ...queries,
      bookingId: record.id,
    });
  };

  return (
    <TableLayout
      rowKey="booking"
      columns={filteredColumns}
      dataSource={displayBookings}
      selectedId={selectedBooking?.id}
      totalNumber={bookingsNo}
      onClickRow={onClickRow}
      current={pageNumber}
      onPageChanged={onPageChanged}
    />
  );
};

export default withPaginatedQueryFetch(BookingsTable, fetchBookings);
